// Article Record Class

import * as Utils from "@/utils/utils";
import store from "@/store/store";

export default class ArtRecFromDB {

	constructor(dat) {
		const src			= dat || {};

		this.rid		= src.rid			|| 0;
		this.itemId		= src.item_id		|| "";
		this.live		= src.live			|| "";
		this.stage		= src.stage			|| "";
		this.merit		= src.merit			|| "";
		this.title		= src.title			|| "";
		this.credit		= src.credit		|| "";
		this.pixId		= src.pix_id		|| "";
		this.catId		= src.cat_id		|| "";
		this.summTxt	= src.summ_text		|| "";
		this.mainTxt	= src.main_text		|| "";
		this.logId		= src.log_id		|| "";
		this.remAddr	= src.rem_addr		|| "";
		this.browser	= src.browser		|| "";
		this.descr		= src.descr			|| "";
		this.notes		= src.notes			|| "";
		this.catItemId	= src.cat_item_id	|| "";
		this.catTitle	= src.cat_title		|| "";
		this.imgName	= src.img_name		|| "";
		this.thmName	= src.thm_name		|| "";
		this.dir		= src.dir			|| "";
		this.dateCre	= src.date_cre		|| "";
		this.dateMod	= src.date_mod		|| "";

		this.fullTxt = this.mainTxt.trim();
		this.summTxt = this.summTxt.trim();
	
		// Combine summary & main text
		if (this.summTxt.length > 0) this.fullTxt = this.summTxt + "\n\n" + this.fullTxt;

		// Format visual date
		this.dateVis = Utils.calcVisDate(this.dateCre);

		// Main Pix Index
		this.mainIdx = 0;

		const state = store.getters["app/state"];
		let newCat = state.cats[0]; 
		for (let cat of state.cats) if (cat.itemId == this.catId) newCat = cat;
		this.cat = newCat;

	}


}
